/**
 * Created by alex.y on 8/8/2017.
 */
import {Directive, forwardRef, Input} from '@angular/core';
import {Validator, AbstractControl, NG_VALIDATORS} from '@angular/forms';
import {Location} from "../../../objects/management/locationManagement/location";
import {ExtraDataService} from "../../../services/extraDataService";

@Directive({
    selector: '[validateLocationShort][ngControl],[validateLocationShort][ngFormControl],[validateLocationShort][ngModel]',
    providers: [
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => ShortLocationValidatorDirective), multi: true}
    ]
})
export class ShortLocationValidatorDirective implements Validator {
    @Input('validateLocationShort') location: Location;
    @Input() validateState: boolean = false;
    constructor() {
    }

    private onChange: () => void;

    validate(control: AbstractControl): { [key: string]: any } {
        if (!control.value)
            return null;

        if (!this.location || (!this.location.Country))
            return {validateLocationShort: false};

        if ( this.location.Country.toLowerCase() == 'canada' && (this.validateState && !this.location.State))
            return {validateLocationShort: false};

        return null;
    }
}


// WEBPACK FOOTER //
// ./app/common/directives/validators/shortLocationValidator.ts